import { ProjectCard } from "components/GridCards";
import MetaTags from "components/MetaTags";
import AnimatedBox from "components/Elements/AnimatedBox";
import API from "strapi/api";
import { withRouter } from "next/router";
import React from "react";
import { motion, AnimatePresence } from "framer-motion";

class index extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filters: Number(props.filters),
    };
  }

  generateDelay() {
    return Math.floor(Math.random() * 6) + 1;
  }

  handleFilterChange(value) {
    let currentFilters;

    if (this.state.filters == value.target.value) {
      currentFilters = "";
    } else {
      currentFilters = value.target.value;
    }

    this.setState((prevState) => ({
      filters: Number(currentFilters),
    }));
  }

  render() {
    return (
      <main>
        <MetaTags
          title="WORK"
          description="All ZANAD Projects"
          image="/og-image.jpg"
        />
        <div>
          <h1 className="offscreen-title">Projects</h1>
          <div className="w-full min-h-screen px-2 pt-20 mx-auto 768:px-5 768:pt-56">
            <div className="flex flex-wrap">
              {this.props.categories &&
                this.props.categories.map((category, i) => {
                  let delay = this.generateDelay();

                  return (
                    <div className="flex items-start" key={i}>
                      <input
                        hidden
                        id={i}
                        type="radio"
                        name="filter"
                        checked={
                          this.state.filters === category.id ? "checked" : ""
                        }
                        value={category.id}
                        className="peer"
                        onChange={(e) => {
                          this.handleFilterChange({
                            target: {
                              name: e.target.name,
                              value: e.target.value,
                              checked: e.target.defaultChecked,
                            },
                          });
                        }}
                      />
                      <label
                        htmlFor={i}
                        className={`cursor-pointer uppercase fluid-type leading-none relative animated-border inline-block dark-border peer-checked optical-align letter-${category.attributes.title.charAt(
                          0
                        )}`}
                      >
                        <AnimatedBox num={delay}>
                          {category.attributes.title}
                        </AnimatedBox>
                      </label>
                      <span className="text-20 640:text-30 block mx-2 991:ml-2 991:mr-5 text-[#8f8f8f]">
                        {category.attributes.works.data &&
                        category.attributes.works.data.length ? (
                          <AnimatedBox num={delay}>
                            {category.attributes.works.data.length}
                          </AnimatedBox>
                        ) : (
                          <></>
                        )}
                      </span>
                    </div>
                  );
                })}
            </div>
            <section className="mt-8 mb-10">
              <AnimatePresence initial="false" exitBeforeEnter>
                <motion.div
                  className="grid grid-cols-2 640:grid-cols-12 gap-x-5 gap-y-2 768:gap-y-8"
                  exit={{ opacity: 0 }}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.3, ease: [0.19, 1, 0.22, 1] }}
                  key={this.state.filters}
                >
                  {this.props.projects.length &&
                    this.props.projects
                      .filter((project) =>
                        this.state.filters
                          ? project.work_category.data
                              .map((category) => category.id)
                              .includes(this.state.filters)
                          : true
                      )
                      .map((project, i) => {
                        return (
                          project.thumbnail && (
                            <div className="col-span-2 640:col-span-6" key={i}>
                              <ProjectCard
                                projectLink={"/work/" + project.slug}
                                imageUrl={API.getNextOriginalImage(
                                  project.thumbnail.data.attributes.url
                                )}
                                title={project.title}
                                client={project.client}
                                year={project.year}
                                index={i}
                              />
                            </div>
                          )
                        );
                      })}
                </motion.div>
              </AnimatePresence>
            </section>
          </div>
        </div>
      </main>
    );
  }
}

export default withRouter(index);

export async function getStaticProps(ctx) {
  let [projects, categories] = await Promise.all([
    API.getProjects(),
    API.getColletionType("work-categories", "sort=order%3Aasc"),
  ]);

  return {
    props: { projects: projects, categories: categories },
    revalidate: 10,
  };
}
